<template>
  <div>
    <div class="vx-card__body card-body">
      <div class="flex">
        <div class="w-full mb-base">
          <data-grid
            ref="grid"
            stripe
            :data-source="gridDataSource"
            :search-data="gridSearchData"
            :columns="[
              { title: $t('CustomerName') },
              { title: $t('SiteOrderNumber') },
              { title: $t('CreateOn') },
              { title: $t('Action') }
            ]"
          >
            <template slot-scope="{ row }">
              <td style="width: 25%">
                {{ row.checkOutInfo.dischargePermissionIssuerUserName }}
              </td>
              <td style="width: 15%">
                {{ row.draftOrderInfo.basketId }}
              </td>
              <td style="width: 15%;direction: ltr;">
                {{ row.createOn.split(" ")[0] }}<br />{{
                  row.createOn.split(" ")[1]
                }}
              </td>
              <td style="width: 30%">
                <router-link
                  :to="{
                    path: '/Package/Details/0/' + row.id,
                    query: {
                      breadcrumbNameManual: {
                        persianTitle: 'مرسولات',
                        Title: 'Package'
                      }
                    }
                  }"
                >
                  <vs-button
                    radius
                    color="success"
                    type="gradient"
                    icon-pack="feather"
                    icon="icon-eye"
                    class="mx-4 d-inline"
                  ></vs-button>
                </router-link>
              </td>
            </template>
          </data-grid>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";

export default {
  name: "shipping-OperationOperators-waitingfordeliverytocustomer",
  components: {
    DataGrid
  },
  data() {
    return {
      permission297: "ChangePackageStateToDelivered",
      gridDataSource: {
        type: "app",
        service: "Shipping/api/PackagesQuery/by-logged-in-operator"
      },
      gridSearchData: {
        packageStateType: 2
      }
    };
  }
};
</script>
